export default __webpack_public_path__ + "static/media/office2.c694279b.jpg";